export default __webpack_public_path__ + "static/media/bg-nav-be-productive.f0e5a1d8.jpg";